import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {UtilisateurModel} from '../../models/utilisateur';
import {Firestore, collection, collectionData, deleteDoc, doc, setDoc} from '@angular/fire/firestore';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {Auth, createUserWithEmailAndPassword} from '@angular/fire/auth';

@Component({
  selector: 'app-utilisateurs',
  templateUrl: './utilisateurs.component.html',
  styleUrls: ['./utilisateurs.component.scss'],
  standalone: false
})
export class UtilisateursComponent implements OnInit {
  nouvelUtilisateur = new UtilisateurModel();
  displayedColumns: string[] = ['prenomNom', 'debutPlage', 'identifiant', 'role', 'actions'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private auth: Auth,
    private db: Firestore,
    private snackBar: MatSnackBar, private authService: AuthService, private router: Router) {
    const usersRef = collection(this.db, 'utilisateurs');
    collectionData(usersRef, {idField: 'id'}).subscribe((datas: any[]) => {
      this.dataSource = new MatTableDataSource(datas);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  ngOnInit() {
    this.authService.isLoggedIn.subscribe((isLoggedIn) => {
      if (!isLoggedIn) {
        this.router.navigate(['/connexion']);
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async valider() {
    if (!this.nouvelUtilisateur.prenomNom) {
      this.message('Le champs prénom et nom est obligatoire');
    } else if (!this.nouvelUtilisateur.debutPlage) {
      this.message('Le champs début plage est obligatoire');
    } else if (!this.nouvelUtilisateur.identifiant) {
      this.message('Le champs identifiant est obligatoire');
    } else if (!this.nouvelUtilisateur.motDePasse) {
      this.message('Le champs mot de passe est obligatoire');
    } else if (!this.nouvelUtilisateur.role) {
      this.message('Le champs rôle est obligatoire');
    } else {
      const credential = await createUserWithEmailAndPassword(
        this.auth,
        this.nouvelUtilisateur.identifiant + '@bbetelecom.fr', this.nouvelUtilisateur.motDePasse);
      await setDoc(doc(this.db, 'utilisateurs', credential.user.uid), JSON.parse(JSON.stringify(this.nouvelUtilisateur)))
        .then(_ => {
          this.message('Utilisateur ajouté avec succès !');
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  supprimer(id) {
    deleteDoc(doc(this.db, 'utilisateurs', id)).then(_ => {
      this.message('Utilisateur supprimé avec succès !');
    }).catch((error) => {
      console.log(error);
    });
  }

  message(message, duration = 3000) {
    this.snackBar.open(message, null, {duration});
  }
}
